import { gql } from "@apollo/client";

export const GetWidgetDetails = gql`
  query GetWidgetDetails($widgetId: String!) {
    getWidgetDetails(widgetId: $widgetId) {
      company {
        id
        name
        widgetId
        archived
        products
        personaTemplateId
      }
      group {
          id
          name
          type
          legalDesc
          distributionType
      }
      memberCompanies {
          id
          name
          widgetId
          archived
          products
      }
      productIntegrations {
        integrations
        product
      }
      fields {
          product
          integration
          channel
          key
          value
      }

      widgetOverrides
    }
  }
`;
